import React from 'react'
import { Dialog, DialogProps } from '../'
import { makeStyles } from '@material-ui/styles'
import { ManWithDesktopPrimary } from '~/assets/illustrations'
import { Box, Button, Typography } from '@material-ui/core'
import { useIsMobileScreen } from '~/hooks'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  button: {
    height: 56,
    fontWeight: 700,
    textTransform: 'none'
  }
})

export const MobileDeviceWarningModal: React.FC<DialogProps> = (props) => {
  const classes = useStyles()
  const isMobile = useIsMobileScreen()

  return (
    <Dialog {...props}>
      <Box className={classes.container}>
        <ManWithDesktopPrimary width={175} height={175} />
        <Typography sx={{ marginTop: 1, fontWeight: 700, textAlign: 'center' }} variant={isMobile ? 'airbnbH5' : 'airbnbH3'}>Olá! Identificamos que você está acessando a página pelo celular</Typography>
        <Typography sx={{ marginTop: 2, marginBottom: 3, textAlign: 'center' }} variant={isMobile ? 'airbnbBody2' : 'airbnbBody1'}>
          Para sua comodidade, sugerimos o uso da nossa plataforma através de um computador.
        </Typography>
        <Button
          disabled={false}
          color='primary'
          variant='contained'
          onClick={props.onClose}
          className={classes.button}
          size={isMobile ? 'large' : 'large'}
        >
          Ok, entendi
        </Button>
      </Box>
    </Dialog>
  )
}
